import { ListPaginationMeta } from "utils/helpers/pagination";

export interface RoofTypeRow {
  beamTypeId: number;
  beamTypeDesc: string;
  beamMaxHeight?: number;
}

export interface RoofTypeForm {
  number: string;
  description: string;
  maxHeight: string;
}

export enum FieldKind {
  String = "string",
  Number = "number",
}

export const FIELD_KIND: Record<keyof RoofTypeForm, FieldKind> = {
  number: FieldKind.Number,
  description: FieldKind.String,
  maxHeight: FieldKind.Number,
};

export type RoofTypeListMeta = ListPaginationMeta;

export interface RoofTypeListResponse {
  statusCode: number;
  message: string | Record<string, string>;
  data: RoofTypeRow[];
  meta?: RoofTypeListMeta;
}

export interface RoofTypeUpdate {
  id: number;
  beamTypeDesc: string;
  beamMaxHeight: number;
}

export interface RoofTypeDetailResponse {
  statusCode: number;
  message: string | Record<string, string>;
  data: RoofTypeRow;
}

export interface RoofTypeState {
  loading: boolean;
  saving: boolean;
  list: RoofTypeRow[];
  page: number;
  perPage: number;
  meta: RoofTypeListMeta;
  error: string | null;
  isAddModalOpen: boolean;
  form: RoofTypeForm;
  detail: RoofTypeRow | null;
  detailLoading: boolean;
  detailError: string | null;
}
